import { useQuery } from "@tanstack/react-query";
import { getOrganList } from "../organ";
import { DefaultFilter } from "../../@types/filter";

type Props = DefaultFilter;

export function useGetOrganList(props: Props = {}) {
  const query = useQuery({
    queryKey: ["organs", props],
    queryFn: async () => getOrganList(props),
  });

  const response = query?.data;

  const organList = response?.data?.results ? response?.data?.results : [];

  return {
    organList,
    ...query,
  };
}
